<template>
<div class="form-group row">  
  <label :for="inputId" class="col-md-12" >{{label}}</label>
  <div class="col-md-6" > 
    <vue-select-search 
      :list="searchResult"
      option-value="value"
      option-text="label"
      v-model="selectedOption"
      :inputId="inputId"
      :id="inputId"
      @searchchange="doSearch"
      :custom-text="displayOption"
      :filterPredicate="customFilter"

    />
  </div>  
  <div class="col-md-1" style="padding: 0px"  >
     <button type="button" aria-label="Move"  v-on:click="moveElement" >
        <span aria-hidden="true"  >&#9658;</span>
      </button>
  </div>  
  <div class="col-md-5"  >
    <div class="places"  v-for="(place, index) in valuesList">
      <div class="row" style="background-color: #EEEEEE; margin-top: 1px; margin-right: 1px;" >
        <div class="col-md-12" style="padding: 2px">
          <button type="button" aria-label="Delete" class="close"  v-on:click="removeElement(place)"  >
            <span aria-hidden="true"  class="align-middle">&times;</span>
          </button>
          {{showLabel(place)}}
        </div>
        
      </div>
    </div>  
    <div v-if="value == null || value.length == 0" class="col-md-12 text-center align-middle" >{{emptyLabel}}</div>
  </div>  
  <span v-show="errors.has(inputId)" class="help is-invalid">{{ errors.first(inputId) }}</span>
</div> 
</template>
<script>

import Vue from 'vue'
import VeeValidate from 'vee-validate'
import { ModelListSelect } from 'vue-search-select'
import _ from 'lodash'
import * as usaStates from '../../../api/usastates.json'

Vue.use(VeeValidate, { fastExit: false })

function _sort (results) {
  results.sort(function (a, b) {
    if (a.ref > b.ref) { return 1 }
    if (a.ref < b.ref) { return -1 }
    return 0
  })
}

function _capitalize (val) {
  return val.charAt(0).toUpperCase() + val.substr(1).toLowerCase()
}

function escapedRegExp (str) {
  return new RegExp(str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')
}

export default {
  inject: ['$validator'],
  data: () => {
    return {
      selectedOption: {},
      searchResult: [],
      searchText: '',
      listResults: [],
      firebaseNode: 'PLACE_COMPONENT',
      valuesList: []
    }
  },
  created: function () {
    const onResult = (results) => {
      this.listResults = results
      this.mountList()
    }
    this.$store.dispatch('fetchDatabase', { firebaseNode: this.firebaseNode, onFetchResult: onResult })
  },
  props: {
    value: { type: String, default: '' },
    inputId: { type: String },
    label: { type: String },
    validationRule: {type: String, default: 'required'},
    options: { type: Array, default: function () { return [] } },
    emptyLabel: {type: String, default: 'No Values selected'}
  },
  components: {
    'vue-select-search': ModelListSelect
  },
  methods: {
    customFilter (text, inputText) {
      let strArr = inputText.split(' ')
      for (let i = 0; i < strArr.length; i++) {
        const val = strArr[i]
        if (isNaN(val.trim()) && val.length === 2) {
          const st = usaStates[val.toUpperCase()]
          if (st) {
            strArr[i] = st
          }
        }
      }
      inputText = strArr.join(' ')
      return text.replace(/(,)/g, '').match(escapedRegExp(inputText))
    },
    displayOption: function (obj) {
      return obj.label
    },
    doSearch (searchText) {
      if (searchText === '') {
        return
      }
      this.searchText = searchText
      // console.log('->' + searchText)
      const allResults = []
      const idx = this.$store.getters.searchIndex(this.firebaseNode)
      const branch = this.$store.getters.searchConfig(this.firebaseNode, 'branch')
      const postalCode = this.$store.getters.searchConfig(this.firebaseNode, 'postalCode')
      const city = this.$store.getters.searchConfig(this.firebaseNode, 'city')
      const state = this.$store.getters.searchConfig(this.firebaseNode, 'state')

      let results = idx.search(searchText, state)
      _sort(results)
      _.forEach(results, (item) => {
        let arr = item.ref.split('|')
        let state = arr[0]
        let label = `${usaStates[state]}`
        let itemId = `${state}`
        allResults.push({ value: itemId, label: label, type: 'state' })
      })

      results = idx.search(searchText, city)
      _sort(results)
      _.forEach(results, (item) => {
        let arr = item.ref.split('|')
        let state = arr[1]
        let arrCity = arr[0].split(' ')
        for (let i = 0; i < arrCity.length; i++) {
          arrCity[i] = _capitalize(arrCity[i])
        }
        const city = arrCity.join(' ')
        let label = `${city.trim()}, ${usaStates[state]}`
        let itemId = `${city.trim()},${state}`
        allResults.push({ value: itemId, label: label, type: 'city' })
      })

      results = idx.search(searchText, postalCode)
      _sort(results)
      _.forEach(results, (item) => {
        let arr = item.ref.split('|')
        let state = arr[2]
        let postalCode = arr[0]
        let arrCity = arr[1].split(' ')
        for (let i = 0; i < arrCity.length; i++) {
          arrCity[i] = _capitalize(arrCity[i])
        }
        const city = arrCity.join(' ')
        let label = `${city.trim()}, ${usaStates[state]} ${postalCode}`
        let itemId = `${city.trim()},${state} ${postalCode}`
        allResults.push({ value: itemId, label: label, type: 'postalCode' })
      })

      results = idx.search(searchText, branch)
      _sort(results)
      _.forEach(results, (item) => {
        let obj = this.$store.getters.firebaseDataMap('LocalBusinesses')[item.ref.replace('#', '')]
        let label = `#${obj.id} - ${obj.address.streetAddress}, ${obj.address.postalCode}, ${obj.address.addressLocality}, ${usaStates[obj.address.addressRegion]}, ${obj.address.addressCountry}`
        allResults.push({ value: item.ref, label: label, type: 'branch' })
      })

      this.searchResult = allResults
    },
    moveElement: function (event) {
      var values = _.cloneDeep(this.valuesList)
      if (!Array.isArray(values)) {
        values = []
      }
      // check if already exists
      const selectedOption = this.selectedOption
      const obj = selectedOption // this.$store.getters.firebaseDataMap(this.firebaseNode)[selectedOption.value]
      var exists = values.some(function (el) {
        return el.label === selectedOption.label
      })
      if (exists) {
        alert('This Place was added.')
        return
      }
      values.push(obj)
      let finalValue = ''
      _.forEach(values, (item) => {
        console.log(item.value)
        finalValue += item.value.replace(/(\||,)/g, ',') + ';'
      })
      this.valuesList = values
      console.log(finalValue)
      this.$emit('input', finalValue)
    },
    removeElement: function (obj) {
      var r = confirm('Are you sure do you wanna remove "' + this.showLabel(obj) + '"?')
      if (!r) {
        return
      }
      var values = _.cloneDeep(this.valuesList)
      values = values.filter(function (el) {
        return JSON.stringify(el) !== JSON.stringify(obj)
      })
      let finalValue = ''
      _.forEach(values, (item) => {
        finalValue += item.value + ';'
      })
      this.valuesList = values
      console.log(finalValue)
      this.$emit('input', finalValue)
    },
    showLabel: function (obj) {
      if (obj['name'] != null) {
        return obj['name']
      } else if (obj['label'] != null) {
        return obj['label']
      }
      return obj
    },
    mountList: function () {
       // remount all values
      let locationMap = this.$store.getters.firebaseDataMap('LocalBusinesses')
      this.valuesList = []
      if (this.value != null && this.value.length > 0) {
        let arr = this.value.trim().split(';')

        for (let i = 0; i < arr.length; i++) {
          let place = arr[i].replace(/(\||,)/g, ',').split(',')
          if (place.length === 1 && place[0].length === 0) {
            continue // empty guy
          }
          if (place.length === 1 && !isNaN(place[0])) { // branchCode
            place[0] = place[0].replace('#', '')
            let obj = locationMap[place[0]]
            if (obj) {
              let label = `#${obj.id} - ${obj.address.streetAddress}, ${obj.address.postalCode}, ${obj.address.addressLocality}, ${usaStates[obj.address.addressRegion]}`
              this.valuesList.push({ value: arr[i], label: label, type: 'branch' })
            }
          } else if (place.length === 1 && isNaN(place)) { // state
            let state = place[0]
            state = usaStates[state]
            let label = `${state}`
            this.valuesList.push({ value: arr[i], label: label, type: 'state' })
          } else if (place.length === 2) { // city or zipcode
            let state = place[1].trim()
            let arrCity = place[0].split(' ')
            for (let i = 0; i < arrCity.length; i++) {
              arrCity[i] = _capitalize(arrCity[i])
            }
            const city = arrCity.join(' ')
            if (state.length >= 2) {
              const st = state.substr(0, 2)
              const stateName = usaStates[st]
              state = state.replace(st, stateName)
            }
            let label = `${city.trim()}, ${state}`
            this.valuesList.push({ value: arr[i], label: label, type: 'city/zipcode' })
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// place-input.vue?8da6db92